export const getListIdTableDetailPortfolio = (data) =>
  data.map((item) => item?.organizationId)

export const convertDataTableDetailPortfolio = (data) => {
  const ids = getListIdTableDetailPortfolio(data)

  const convertObj = (data) => {
    return {
      ...data,
      status: {
        activeStatusName: data?.activeStatusName,
        activeStatusId: data?.activeStatusId,
      },
    }
  }

  const objData = {}
  ids.forEach((id) => {
    objData[id] = convertObj({
      ...data.find((item) => item.organizationId === id),
    })
  })

  return objData
}

export const getDataSizeTable = (data) => ({
  page: data?.page,
  pageSize: data?.pageSize,
  totalRecords: data?.totalRecords,
  totalPage: data?.totalPage,
})

export const convertDataTableAddCompany = (data, item, isApi) => {
  if (isApi) {
    const arr = data
    item.forEach((value) => {
      const check = data.some((key) => key.id === value.id)
      if (check) return [...data]
      arr.push(value)
    })
    return arr
  } else {
    const check = data.some((key) => key.id === item.id)
    if (check) return [...data]
    return [...data, item]
  }
}

export const convertDataReduxTableAddCompany = (data, ids) => {
  const obj = {}
  ids.forEach((item, index) => {
    obj[item] = { ...data[index], stt: index + 1 }
  })
  return obj
}

export const convertDataAddCompanyApi = (data) => {
  return data.map((item) => ({
    taxCode: item?.taxCode,
    companyName: item?.organizationName,
    id: item?.organizationId,
  }))
}
